import { Component ,OnInit,Inject} from '@angular/core';
import { MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { SidebarService } from '../sidebar/sidebar.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { v_User, Parent_Permision } from '../sidebar/model';
import { Common } from '../global/common';
import { RequestData } from '../Model/RequestData';
import { Claims } from '../sidebar/Claims';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
})
/** header component*/
export class HeaderComponent implements OnInit{
  public iduser: string;
  public Permission: Parent_Permision[];
  public user: v_User;
  public claims : Claims;

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    public http: HttpClient, public globals: Common,  private sidebarService: SidebarService) {
    console.debug("HeaderComponent");
    this.iduser = globals.IdUser;  

  }



  get isSidebarVisible(): boolean {
    return this.sidebarService.isSidebarVisible;
  }

  ngOnInit() {
    this.GetName();
  }

   async GetName() {    
    this.user =  await JSON.parse(localStorage.getItem("ResponseData"));
    this.claims =  await JSON.parse(localStorage.getItem("Claims"));
  }


  logout() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
    localStorage.removeItem('ResponseData');
    localStorage.removeItem('Claims');
    localStorage.removeItem('profile');
    sessionStorage.clear();
  }
}